var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "product-aside", attrs: { id: "product_aside" } },
        [
          _c(
            "section",
            { staticClass: "product-aside-heading" },
            [
              _c(
                "Heading",
                { attrs: { product: _vm.product } },
                [
                  _c("Price", {
                    attrs: {
                      product: _vm.product,
                      validInCurrentMarket: _vm.validInCurrentMarket,
                    },
                  }),
                  _vm._v(" "),
                  _vm.product.product_reviews &&
                  _vm.product.product_reviews.aggregate_summary &&
                  _vm.product.product_reviews.aggregate_summary
                    .stars_average_rounded_to_fives >= 4
                    ? _c("Reviews", {
                        attrs: {
                          count:
                            _vm.product.product_reviews.aggregate_summary
                              .number_of_reviews.total,
                          rating:
                            _vm.product.product_reviews.aggregate_summary
                              .stars_average_rounded_to_fives,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.validInCurrentMarket
                    ? _c("MarketExclusiveLabel")
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Description", { attrs: { product: _vm.product } }),
                  _vm._v(" "),
                  _vm.upstreamConnectionFailure
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "product-aside-heading-upsteam-connection-error",
                        },
                        [
                          _vm._v(
                            "\n        ⚠️ There is currently an issue connecting to the stock control system. Please enter your email below and we can alert you as soon as this is resolved.\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showProductActions
                    ? _c("Actions", {
                        ref: "mainAction",
                        attrs: {
                          product: _vm.product,
                          variantStock: _vm.variantStock,
                          isOutOfStock: _vm.isOutOfStock,
                          upstreamConnectionFailure:
                            _vm.upstreamConnectionFailure,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("EnquireNow", { attrs: { product: _vm.product } }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.feature.product_page_ux !== "1_0" ? _c("Delivery") : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.feature.product_page_ux !== "1_0" && _vm.validInCurrentMarket
            ? _c(
                "div",
                {
                  staticClass: "sticky-add-to-cart",
                  class: { "sticky-add-to-cart--active": _vm.stickyActive },
                },
                [
                  _c(
                    "div",
                    { staticClass: "sticky-add-to-cart-actions" },
                    [
                      _vm.showProductActions
                        ? _c("Actions", {
                            attrs: {
                              product: _vm.product,
                              variantStock: _vm.variantStock,
                              isOutOfStock: _vm.isOutOfStock,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }